import { CheckIcon, ChevronDownIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { cn } from "@/lib/utils";

// Ledger years go live one at a time; extend as new years accrue data
const TRACKER_YEARS = [2026, 2025];

export const EarningsYearDropdown = ({
  onYearChange,
  year,
}: {
  onYearChange: (year: number) => void;
  year: number;
}) => {
  /* Render */
  const render = () => (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outlineSecondary"
          size="sm"
          className="h-7 gap-1 rounded-full border-slate-300 bg-slate-50 px-2.5 text-xs font-medium text-slate-900"
        >
          {String(year)}
          <ChevronDownIcon className="h-3.5 w-3.5 text-slate-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[100px]">
        {TRACKER_YEARS.map((option) => (
          <DropdownMenuItem
            key={option}
            className={cn(
              "justify-between gap-2 text-xs",
              option === year && "bg-slate-50 font-medium",
            )}
            onSelect={() => {
              onYearChange(option);
            }}
          >
            {String(option)}
            <CheckIcon
              className={cn(
                "h-3.5 w-3.5 shrink-0",
                option === year ? "opacity-100" : "opacity-0",
              )}
            />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );

  return render();
};
